import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { NavbarOfflineLink } from './NavbarOfflineLink';
export const NavbarLink = (props) => {
    const linkProps = props.linkTo
        ? { component: RouterLink, to: props.linkTo }
        : { onClick: props.click };
    if (props.offlineMode) {
        return (_jsx(NavbarOfflineLink, { text: props.text, children: props.children }, props.linkKey));
    }
    return (_jsx(Link, { ...linkProps, color: "inherit", underline: 'none', children: _jsxs(ListItem, { button: true, children: [_jsx(ListItemIcon, { children: props.children }), _jsx(ListItemText, { primary: props.text })] }, props.linkKey) }));
};
